import { StoreFeature } from "../../../core/store/types";
import { BrowseView } from "../../types";

export const browseView: StoreFeature<BrowseView> = {}
